export const transformColorLabelToPathname = (colorLabel: string) => {
  if (typeof colorLabel !== 'string' || !colorLabel) return '';

  return colorLabel
    .trim()
    .toLowerCase()
    .replace(/\s|&amp;|&|\+|\//g, match => (match === ' ' ? '-' : ''))
    .replace(/-+/g, '-');
};
